import { useContext } from "react";
import AppContext from "../../context";
import { readableColor } from "color2k";
import variables from "../../styles/export.module.scss";

const InsertName = () => {
  const { handleSetInsertName, insertName } = useContext(AppContext);

  const labelStyle = {
    color: readableColor(variables.menuBgColor),
  };

  return (
    <div className="settings-container" id="insertNaming">
      <p className="settings--title title is-size-6" style={labelStyle}>
        Insert Name (Optional)
      </p>

      <form className="settings--switch pb-4 pt-0">
        <div className="field" style={{ width: "100%" }}>
          <div className="control">
            <input
              className="input"
              type="text"
              maxLength="90"
              value={insertName}
              onChange={(e) => {
                if (e.target.value === "") handleSetInsertName(null);
                else handleSetInsertName(e.target.value);
              }}
              placeholder="Enter Insert Name..."
            />
          </div>
        </div>
      </form>
      <hr className="horizontal"></hr>
    </div>
  );
};

export default InsertName;
